import template from './groupsTreeBranch.html';


/* @ngInject */
export default function GroupsTree($compile, filterFilter) {
  return {
    restrict: 'E',
    template,
    replace: true,
    bindToController: true,
    scope: {
      root: '=?',
      disabled: '=?',
      item: '=',
      remove: '=',
      action: '&',
      actionRef: '=',
      filterQuery: '<',
      level: '<',
      isGroupSelected: '=?'
    },
    controllerAs: '$ctrl',
    controller() { /* Placeholder so scope can bind */ },
    link: GroupsTreeLink
  };

  function GroupsTreeLink(scope, element, __attrs, ctrl) {
    ctrl.hide = ctrl.level > 1; // initially hide all but top level
    ctrl.filterGroup = filterGroup;

    // ng-hide does not destroy elements, filter on ng-repeat does and would destroy ctrl.hide status on query change
    const subgroupHtml =
        `<ul class="sub-list">
          <groups-tree-branch
            ng-repeat="subGroup in $ctrl.item.subGroups"
            disabled="$ctrl.disabled || $ctrl.isGroupSelected(subGroup.id)"
            root="$ctrl.root"
            ng-hide="$ctrl.filterGroup(subGroup, $ctrl.filterQuery)"
            item="subGroup"
            remove="$ctrl.remove && !$ctrl.root || $ctrl.disabled && $ctrl.root"
            action="$ctrl.actionRef(grp)"
            action-ref="$ctrl.actionRef"
            filter-query="$ctrl.filterQuery"
            level="$ctrl.level ? $ctrl.level + 1 : $ctrl.level"
            is-group-selected="::$ctrl.isGroupSelected"
          >
          </groups-tree-branch>
        </ul>`;

    function filterGroup(groups, query) {
      return (query && filterFilter([...groups.subGroups, groups.name], query).length === 0) ||
          (!query && ctrl.hide);
    }

    scope.$watch(() => ctrl.item.subGroups, () => {
      element.append($compile(subgroupHtml)(scope));
    });

    $compile()(scope);

    if (ctrl.remove) {
      element.find('div').hover(
        (ev) => {
          ev.preventDefault();
          element.find('div')
            .addClass('child-hovered');
        },
        () => {
          element.find('div')
            .removeClass('child-hovered');
        }
      );
    } else {
      element.find('div').hover(
        function (ev) {
          ev.preventDefault();
          $(this).parentsUntil($('.group-tree'), 'li')
            .children('div')
            .addClass('child-hovered');
        },
        function () {
          $(this).parentsUntil($('.group-tree'), 'li')
            .children('div')
            .removeClass('child-hovered');
        }
      );

      scope.$on('$destroy', () => {
        element.parentsUntil($('.group-tree'), 'li')
          .children('div')
          .removeClass('child-hovered');
      });
    }
  }
}
